import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ISelectOptions } from '../../interfaces/internal-interfaces';
import { IApproverList } from '../../scripts/approvers';
import { ContractHandler } from '../../scripts/contracts/contract-handler';
import { ExtDocument } from '../../scripts/extDocument';

type IIterableItemTypes = IApproverList | ContractHandler | ISelectOptions | ExtDocument;

@Component({
  selector: 'bar-select',
  templateUrl: './bar-select.component.html',
  standalone: false,
})
export class BarSelectComponent implements OnInit {
  @Input() public items: IIterableItemTypes[] = [];
  @Input() public innerClass = '';
  @Input() public isSearching = false;
  @Input() public itemName = 'Items';
  @Input() public nullMessage: string | undefined;
  @Output() public readonly itemChosen = new EventEmitter();

  public ngOnInit(): void {
    if (!this.nullMessage) this.nullMessage = `No ${this.itemName} Found`;
  }

  public select(item: IIterableItemTypes): void {
    this.itemChosen.emit(item);
  }
}
